import { IBillsFilters } from "../models/bills.model";

export class SearchBillsListAction {
  static readonly type = "[Bills] SearchBillsListAction";
  constructor(public payload: { filter: IBillsFilters }) {}
}